module.exports = __webpack_public_path__ + "img/tab-system-selected.84e03561.png";